import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logoHorizontal from '../../assets/images/logo-horizontal.svg';
import watermark from '../../assets/shapes/watermark-union.svg';
import revealPassword from '../../assets/icons/reveal-password.svg';
import axiosApi from '../../api/axiosApi';
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import { loadUser } from '../../store/slice/KorisnikSlice';
import JWTTokenService from '../../common/service/JWTTokenService';

import ZahtjeviService from '../../service/ZahtjeviService';
import { Zahtjev } from '../../common/types/types';
import { setDohvaceniZahtjevi } from '../../store/slice/ZahtjeviSlice';
import { zahtjevToZahtjevTable } from '../../common/utils/HelperFunction';

export const Login = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [revealPasswordBtn, setRevealPasswordBtn] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  //Redux
  const dispatch = useAppDispatch();
  const { korisnik } = useAppSelector((state) => state);

  //React Router
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  //-------------------------------------------------------------
  //Dohvaćanje svih zahtjeva
  const getZahtjevi = () => {
    ZahtjeviService.getZahtjevi().then((response) => {
      let sviZahtjevi: Array<Zahtjev> = response.data;
      ZahtjeviService.getArchivedZahtjevi().then((responseArchived) => {
        sviZahtjevi = [...sviZahtjevi, ...responseArchived.data];
        dispatch(setDohvaceniZahtjevi(zahtjevToZahtjevTable(sviZahtjevi)));
      });

      navigate(from, { replace: true });
    });
  };

  //-------------------------------------------------------------

  const loginUser = async (e: any) => {
    e.preventDefault();

    JWTTokenService.getToken(email, password)
      .then((response) => {
        axiosApi.defaults.headers['Authorization'] = 'Bearer ' + response.data.access;

        dispatch(
          loadUser({
            ...korisnik,
            id: response.data.id,
            username: response.data.username,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            email: response.data.email,
            admin: response.data.admin_role,
            accessToken: response.data.access,
            refreshToken: response.data.refresh,
          })
        );
        //-------------------------------------------------------------

        getZahtjevi();

        //-------------------------------------------------------------
        setErrorMessage('');
      })
      .catch((error) => {
        console.log(error);
        error.response.status === 401 && setErrorMessage('Username or password is incorrect');
        error.response.status === 400 && setErrorMessage('Contact authorities to authorize your account');
      });
  };

  return (
    <div className='login'>
      <div className='login__header'>
        <div className='flex-center relative'>
          <picture className='login__header__logo'>
            <img className='login__header__logo__img' src={logoHorizontal} alt='logo-horizontal' />
          </picture>
          <div className='beta-version color-white font-light font-italic'>
            <span>Beta</span>
          </div>
        </div>
        <img className='login__header__watermark' src={watermark} alt='' />
      </div>
      <div className='login__box'>
        <h3 className='font-h3-regular'>Please Sign in</h3>
        <form className='form' onSubmit={loginUser}>
          <div className='form__item'>
            <label className='font-h6-regular margin-left-1' htmlFor='email'>
              Username
            </label>
            <input className='form__item__input font-h5-regular' type='text' onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className='form__item relative'>
            <label className='font-h6-regular margin-left-1' htmlFor='email'>
              Password
            </label>
            <input
              className='form__item__input font-h5-regular'
              type={revealPasswordBtn ? 'text' : 'password'}
              autoComplete='on'
              onChange={(e) => setPassword(e.target.value)}
            ></input>
            <img className='form__item__img' src={revealPassword} onClick={() => setRevealPasswordBtn(!revealPasswordBtn)} alt='revPass' />
          </div>
          {errorMessage && <p className='text-center margin-bottom-2 color-red'>{errorMessage}</p>}
          <button className='button-primary font-h5-medium text-white full-width' type='submit'>
            Sign in
          </button>
          <div className='full-width-grey-300-line' />
        </form>
        {/* <Link to='/resetPassword' className='login__box__link font-h5-regular primary-200'>
          forgot your password?
        </Link> */}
      </div>
    </div>
  );
};
